<template>
  <div>
    <v-select
      v-model="selectedTheme"
      :items="items"
      @change="setSelectCasinoTheme"
      item-text="text"
      item-value="value"
      :label="$t('filterByCasinoTheme')"
      :menu-props="{ bottom: true, offsetY: true }"
      prepend-icon="mdi-filter-variant-plus"
      dense
      hide-details
      solo-inverted
      clearable
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "select-casino-type",
  data: () => ({
    selectedTheme: [],
  }),
  computed: {
    items() {
      return [
        {
          text: "africa",
          value: "africa",
        },
        {
          text: "ancient_civilizations",
          value: "ancient_civilizations",
        },
        {
          text: "asia",
          value: "asia",
        },
        {
          text: "book_off",
          value: "book_off",
        },
        {
          text: "branded",
          value: "branded",
        },
        {
          text: "easter",
          value: "easter",
        },
        {
          text: "egypt",
          value: "egypt",
        },
        {
          text: "fantasy",
          value: "fantasy",
        },
        {
          text: "food",
          value: "food",
        },
        {
          text: "fruits",
          value: "fruits",
        },
        {
          text: "girls",
          value: "girls",
        },
        {
          text: "halloween",
          value: "halloween",
        },
        {
          text: "horrors",
          value: "horrors",
        },
        {
          text: "joker",
          value: "joker",
        },
        {
          text: "luxury_life",
          value: "luxury_life",
        },
        {
          text: "military",
          value: "military",
        },
        {
          text: "other",
          value: "other",
        },
        {
          text: "party",
          value: "party",
        },
        {
          text: "pirates",
          value: "pirates",
        },
        {
          text: "retro",
          value: "retro",
        },
        {
          text: "space",
          value: "space",
        },
        {
          text: "sport",
          value: "sport",
        },
        {
          text: "st_patrick_day",
          value: "st_patrick_day",
        },
        {
          text: "st_valentines_day",
          value: "st_valentines_day",
        },
        {
          text: "sweets",
          value: "sweets",
        },
        {
          text: "underwater_world",
          value: "underwater_world",
        },
        {
          text: "western",
          value: "western",
        },
        {
          text: "x_mas_and_new_year",
          value: "x_mas_and_new_year",
        },
      ];
    },
  },

  methods: {
    setSelectCasinoTheme(value) {
      this.items.map((item, index) => {
        if (item.value == value) {
          this.toggleValue = index;
        }
      });

      if (value == undefined) {
        this.$store.commit("setSelectCasinoTheme", "");
      } else {
        this.$store.commit("setSelectCasinoTheme", value);
      }
    },
  },
};
</script>